module.exports = __webpack_public_path__ + "img/tributario.80c31247.png";